import React from "react";
import { Link } from "gatsby";
import Logo from "./logo";

function Footer(props) {
  const { container = "container" } = props;
  const { contact } = props.data;
  const handleAddress = (e) => {
    const addr =
      "https://maps.google.com/maps?q=Ohio+Wholesale+Liquidation+%26+Surplus";

    if (navigator.platform.match(/iPhone|iPad|iPod/i))
      window.open(`maps://${addr}`);
    else window.open(`https://${addr}`);

    e.preventDefault();
  };
  return (
    <footer className="footer">
      <div className="footer-middle">
        <div className={container}>
          <div className="row">
            <div className="col-sm-7 col-md-5 col-lg-4">
              <div className="widget widget-about">
                <Logo />
                <p>{props.data.metadata.description}</p>

                <div className="widget-call">
                  {/* <i className="icon-phone"></i>
                  Got Question? Call us 24/7
                  <a href="tel:812-562-5622">812-562-5622</a> */}
                  <div className="social-icons">
                    <a
                      href={`https://www.facebook.com/${contact.facebook}`}
                      className="social-icon"
                      target="_blank"
                      title="Facebook"
                      rel=" noreferrer"
                    >
                      <i className="icon-facebook-f"></i>
                    </a>
                    <a
                      href={`https://www.instagram.com/${contact.instagram}`}
                      className="social-icon"
                      target="_blank"
                      title="Instagram"
                      rel=" noreferrer"
                    >
                      <i className="icon-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-4 col-md-3 col-lg-5">
              <div className="widget">
                <span className="widget-title text-primary">Useful Links</span>

                <ul className="widget-list" style={{ columnCount: 2 }}>
                  {props.data.allPages.nodes.map((page, index) => {
                    return (
                      page?.location?.footer && (
                        <li key={page.title + "" + index}>
                          <Link to={`/${page.slug}/`}>{page.title}</Link>
                        </li>
                      )
                    );
                  })}
                  <li>
                    <Link key={"productrequest"} to={`/productrequest/`}>
                      Request A Product
                    </Link>
                  </li>
                  <li>
                    <Link key={"wholesale"} to={`/wholesale/`}>
                      Wholesale{" "}
                    </Link>
                  </li>

                  <li>
                    <Link key={"contactpage"} to={`/contact/`}>
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link key={"faqspage"} to={`/faqs/`}>
                      FAQS
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-sm-4 col-md-4 col-lg-3">
              <div className="widget">
                <span className="widget-title  text-primary">Contact Us</span>

                <ul className="widget-list">
                  {/* <div className="col  d-md-block">
                    <div className="sub-title">
                      <div className="footer-contant"> */}
                        {contact && (
                          // <ul className="contact-list">
                          <>
                            <li>
                              <i className="fa fa-map-marker"></i>
                              <a href="/" onClick={handleAddress}>
                                {contact.address} , {contact.city},{" "}
                                {contact.state}, {contact.zipCode}
                              </a>
                            </li>
                            <li>
                              <i className="fa fa-phone"></i>
                              <a href={`tel:${contact.phone}`}>
                                {contact.phone}
                              </a>
                            </li>
                            <li>
                              <i className="fa fa-envelope-o"></i>
                              <a
                                href={`mailto:${contact.email}`}
                                style={{ textTransform: "none" }}
                              >
                                {contact.email}
                              </a>
                            </li>
                            </>
                          // </ul>
                        )}
                      {/* </div>
                    </div>
                  </div> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className={container}>
          <p className="footer-copyright">
            Copyright © {new Date().getFullYear()} {props.data.metadata.title}.
            All Rights Reserved. Designed and Developed by{" "}
            <a href="http://www.accelerone.com">Accelerone</a>
          </p>
          <figure className="footer-payments" aria-labelledby="pr-img">
            <img
            id="pr-img"
              loading="lazy"
              src={`/assets/images/payments.png`}
              alt="Payment methods"
              width="272"
              height="20"
            />
          </figure>
        </div>
      </div>
    </footer>
  );
}

export default React.memo(Footer);
